import React from 'react'
import _ from 'lodash'
import { Label } from 'recharts'
import styled from 'styled-components'

const Container = styled.div`
  font-size: 14px;
`

export default ({ theme, lines, content, viewBox, ...rest }) => (
  <>
    {_.map(lines, ({ text, x }, i) => (
      <Container
        key={i}
        as={Label}
        {...rest}
        viewBox={{
          ...viewBox,
          x: viewBox.x + x,
          y: viewBox.y + i * 18,
        }}
        position='insideTopLeft'
      >
        {text}
      </Container>
    ))}
  </>
)
